import React from "react";
import { FC } from "react";
import { mergeStyleSets } from "office-ui-fabric-react";
import { ToastOptions } from "react-toastify";

type Props = {
  title: string;
  content: string;
  buttons?: ButtonProp[];
};

type ButtonProp = {
  text: string;
  action?: () => void;
};

const classes = mergeStyleSets({
  title: {
    fontWeight: "bold",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: "0.0025em",
    color: "#000",
    marginBottom: 12
  },
  content: {
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 14,
    letterSpacing: "0.005em",
      color: "#000",
    whiteSpace: "pre-wrap",
    marginBottom: 12
  },
  buttonContainer: {
    textAlign: "right",
      marginTop: 12
  },
  button: {
    border: "none",
    padding: "7px 14px",
      marginLeft: 8,
      borderRadius: 4
  }
});

export const ToastConfig: ToastOptions = {
  position: "bottom-right",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined
};

const ToastContent: FC<Props> = (props: Props) => (
  <div>
    <div className={classes.title}>{props.title}</div>
    <div className={classes.content}>{props.content}</div>
    {props.buttons && (
      <div className={classes.buttonContainer}>
        {props.buttons.map(b => (
          <button key={b.text} className={classes.button} onClick={b.action}>
            {b.text}
          </button>
        ))}
      </div>
    )}
  </div>
);
export default ToastContent;
